// menuPermissions.js
export const menuPermissions = [
    { name: 'Dashboard', value: 'manage_dashboard' },
    { name: 'Add Users', value: 'manage_users' },
    { name: 'Add Roles', value: 'manage_roles' },
    { name: 'Products', value: 'manage_products' },
    { name: 'Free Products Setup', value: 'manage_freeproducts' },
    { name: 'New Products', value: 'manage_newproducts' },
    { name: 'Customers', value: 'manage_customers' },
    { name: 'Orders', value: 'manage_orders' },
    { name: 'Master Entry', value: 'manage_masterentry' },
    { name: 'Settings', value: 'manage_settings' },
    { name: 'Stripe Payment Log', value:'manage_stripelog'},
    { name: 'Food Solutions', value:'manage_foodsolutions'},
    { name:'Development Chef', value:'manage_chefs'},
    { name:'Head Office', value:'manage_ho'},
    { name: 'Promotions', value:'manage_promotions'},
    { name: 'Promo Offers', value:'manage_promooffers'},
    { name: 'Email Campaign', value:'manage_emailcampaign'},
    { name: 'Food Service Partner', value:'manage_vendorhub'},
    //{ name: 'Kitchen Account', value:'manage_kitchenAccount'},
    // { name: 'View Content', value: 'view_content' },
    // { name: 'Edit Content', value: 'edit_content' },
  ];